// ============================================
// NOTIFICACIONES.JS — Sistema de notificaciones push locales
// ============================================

/**
 * Solicita permiso de notificaciones al usuario.
 * @returns {Promise<string>} 'granted', 'denied' o 'default'
 */
export async function solicitarPermiso() {
  if (!('Notification' in window)) return 'denied';
  if (Notification.permission === 'granted') return 'granted';
  if (Notification.permission === 'denied') return 'denied';
  const permiso = await Notification.requestPermission();
  return permiso;
}

/**
 * Envía una notificación local inmediata.
 * @param {string} titulo
 * @param {string} mensaje
 * @param {string} [url] — URL a abrir al hacer clic
 */
export function enviarNotificacion(titulo, mensaje, url) {
  if (!('Notification' in window) || Notification.permission !== 'granted') return;
  const notif = new Notification(titulo, {
    body: mensaje,
    icon: '/Logo Original Cuadrado.png',
    badge: '/Logo Original Cuadrado.png',
    tag: 'beep-' + Date.now(),
  });
  if (url) {
    notif.onclick = () => {
      window.focus();
      window.location.href = url;
    };
  }
}

/**
 * Programa una notificación para una fecha/hora futura.
 * Usa setTimeout internamente (funciona mientras la app esté abierta).
 * @param {string} titulo
 * @param {string} mensaje
 * @param {Date|string} fecha — Date object o ISO string
 * @returns {number|null} — ID del timeout para cancelar, o null
 */
export function programarNotificacion(titulo, mensaje, fecha) {
  const target = fecha instanceof Date ? fecha : new Date(fecha);
  const delay = target.getTime() - Date.now();
  if (delay <= 0) {
    enviarNotificacion(titulo, mensaje);
    return null;
  }
  return window.setTimeout(() => {
    enviarNotificacion(titulo, mensaje);
  }, delay);
}
